<template>
  <div class="case-detail-sv-filter-dailog dialog col-block width-full">
    <div class="case-detail-sv-filter-main-container col-block width-full">
      <div class="case-detail-sv-filter-main-title-container row-block">
        <div class="case-detail-sv-filter-main-title">{{ $t('DIALOG.caseDetailSVFilter.___title') }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <hr>
      <div class="case-detail-sv-filter-gene-container col-block width-full">
        <div class="case-detail-sv-filter-gene-title-container row-block">
          <div class="case-detail-sv-filter-gene-title">{{ $t('DIALOG.caseDetailSVFilter.gene.___title') }}</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="case-detail-sv-filter-gene-search-container row-block">
          <div class="case-detail-sv-filter-gene-search-block col-block" :style="{ flex: 1 }">
            <div class="row-block flex-start" :style="{ width: '100%' }">
              <div class="case-detail-sv-filter-gene-search-input input-group" :style="{ flex: 1 }">
                <geneTag
                  :style="{ width: '100%' }"
                  :placeholder="$t('DIALOG.caseDetailSVFilter.gene.___placeholder')"
                  :init="tagData.query['gene']"
                  :title="false"
                  :dataInfo="tagData.tag['genes'].info"
                  :genes="tagData.tag['genes'].datas"
                  :needFilter="false"
                  @input="content => { tagData.query['gene'] = content; getGenes(content) }"
                  @tag="content => { tagData.query['gene'] = content.name; tagData.curTag['gene'] = content; }"
                  @send="content => (tagData.tag['genes'].datas || []).length && tagData.query['gene'] ? addToSearch(tagData.curTag['gene'] || tagData.query['gene']) : ''"
                ></geneTag>
                <img :src="require('../../assets/images/search-solid.svg')" alt="">
              </div>
              <div :style="{ width: '22px' }"></div>
              <button class="main-button circle-button" :disabled="!((tagData.tag['genes'].datas || []).length && tagData.query['gene'])" @click="e => (tagData.tag['genes'].datas || []).length && tagData.query['gene'] ? addToSearch('gene', tagData.curTag['gene'] || tagData.query['gene']) : ''">
                <span>{{ $t('COMMON.button.___add') }}</span>
              </button>
            </div>
            <div v-if="searchedDatas['genes'].length" class="case-detail-sv-filter-gene-selected-container col-block flex-start">
              <div class="case-detail-sv-filter-gene-selected-title-container row-block">
                <div class="case-detail-sv-filter-gene-selected-title">{{ $t('DIALOG.caseDetailSVFilter.gene.selected.___title') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="case-detail-sv-filter-gene-selected-item-container row-block flex-wrap">
                <div
                  class="case-detail-sv-filter-gene-item-container case-detail-sv-filter-item-container row-block"
                  v-for="(gene, ghindex) in searchedDatas['genes']"
                  :key="ghindex"
                  :class="{
                    disabled: selectedLimit['genes'] && !selectedDatas['genes'].includes(gene)
                  }"
                  @click="e => {
                    selectedDatas['genes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? selectedDatas['genes']
                      : selectedDatas['genes'].includes(gene) ? selectedDatas['genes'].filter(g => g.gene_id !== gene.gene_id)
                      : selectedDatas['genes'].concat([gene])
                  }"
                >
                  <div class="case-detail-sv-filter-item-block row-block">
                    <img
                      class="checkbox"
                      :src="
                        selectedDatas['genes'].includes(gene) ? require('../../assets/images/checkbox-true.svg')
                        : require('../../assets/images/checkbox-false.svg')
                      "
                    >
                    <div class="case-detail-sv-filter-item-title">{{ gene.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="case-detail-sv-filter-condition-container col-block width-full">
        <div class="case-detail-sv-filter-condition-title-container row-block">
          <div class="case-detail-sv-filter-condition-title">{{ $t('DIALOG.caseDetailSVFilter.condition.___title') }}</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="case-detail-sv-filter-condition-search-container row-block">
          <div class="case-detail-sv-filter-condition-search-block col-block" :style="{ flex: 1 }">
            <div class="row-block flex-start" :style="{ width: '100%' }">
              <div class="case-detail-sv-filter-condition-search-input input-group" :style="{ flex: 1 }">
                <geneTag
                  :style="{ width: '100%' }"
                  :placeholder="$t('DIALOG.caseDetailSVFilter.condition.___placeholder')"
                  :init="tagData.query['phenotype']"
                  :title="false"
                  :dataInfo="tagData.tag['phenotypes'].info"
                  :genes="tagData.tag['phenotypes'].datas"
                  :needFilter="false"
                  @input="content => { tagData.query['phenotype'] = content; getPhenotypes(content) }"
                  @tag="content => { tagData.query['phenotype'] = content.name; tagData.curTag['phenotype'] = content; }"
                  @send="content => (tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'] ? addToSearch(tagData.curTag['phenotype'] || tagData.query['phenotype']) : ''"
                ></geneTag>
                <img :src="require('../../assets/images/search-solid.svg')" alt="">
              </div>
              <div :style="{ width: '22px' }"></div>
              <button class="main-button circle-button" :disabled="!((tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'])" @click="e => (tagData.tag['phenotypes'].datas || []).length && tagData.query['phenotype'] ? addToSearch('phenotype', tagData.query['phenotype']) : ''">
                <span>{{ $t('COMMON.button.___add') }}</span>
              </button>
            </div>
            <div v-if="searchedDatas['phenotypes'].length" class="case-detail-sv-filter-condition-selected-container col-block flex-start">
              <div class="case-detail-sv-filter-condition-selected-title-container row-block">
                <div class="case-detail-sv-filter-condition-selected-title">{{ $t('DIALOG.caseDetailSVFilter.condition.selected.___title') }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div class="case-detail-sv-filter-condition-selected-item-container row-block flex-wrap">
                <div
                  class="case-detail-sv-filter-condition-item-container case-detail-sv-filter-item-container row-block"
                  v-for="(phenotype, phindex) in searchedDatas['phenotypes']"
                  :key="phindex"
                  :class="{
                    disabled: selectedLimit['phenotypes'] && !selectedDatas['phenotypes'].includes(phenotype)
                  }"
                  @click="e => {
                    selectedDatas['phenotypes'] =
                      e.currentTarget.className.split(' ').includes('disabled') ? selectedDatas['phenotypes']
                      : selectedDatas['phenotypes'].includes(phenotype) ? selectedDatas['phenotypes'].filter(p => p.id !== phenotype.id)
                      : selectedDatas['phenotypes'].concat([phenotype])
                  }"
                >
                  <div class="case-detail-sv-filter-item-block row-block">
                    <img
                      class="checkbox"
                      :src="
                        selectedDatas['phenotypes'].includes(phenotype) ? require('../../assets/images/checkbox-true.svg')
                        : require('../../assets/images/checkbox-false.svg')
                      "
                    >
                    <div class="case-detail-sv-filter-item-title">{{ phenotype.name }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="case-detail-sv-filter-variant-database-container col-block width-full">
        <div class="case-detail-sv-filter-variant-database-title-container row-block">
          <div class="case-detail-sv-filter-variant-database-title">{{ $t('DIALOG.caseDetailSVFilter.variantDatabase.___title') }}</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="case-detail-sv-filter-variant-database-main-container row-block flex-start">
          <div
            class="case-detail-sv-filter-variant-database-main-block col-block width-full"
            v-for="(databaseOption, doindex) in variantDatabaseOptions"
            :key="doindex"
            :style="{ flex: 1, 'max-width': '450px' }"
          >
            <div class="case-detail-sv-filter-variant-database-main-title-container row-block">
              <div class="case-detail-sv-filter-variant-database-main-title">{{ databaseOption.title }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div :style="{ height: '10px' }"></div>
            <div class="case-detail-sv-filter-variant-database-selected-item-container">
              <div
                class="case-detail-sv-filter-variant-database-item-container case-detail-sv-filter-item-container row-block"
                v-for="(dataOption, dindex) in databaseOption.options"
                :key="dindex"
                :class="{
                  disabled: false
                }"
                :style="{ 'grid-column': 'span ' + (dataOption.grid) + ' / auto' }"
                @click="e => {
                  selectedDatas[databaseOption.value] =
                    e.currentTarget.className.split(' ').includes('disabled') ? selectedDatas[databaseOption.value]
                    : selectedDatas[databaseOption.value].includes(dataOption.value) ? selectedDatas[databaseOption.value].filter(data => data !== dataOption.value)
                    : selectedDatas[databaseOption.value].concat([dataOption.value])
                }"
              >
                <div class="case-detail-sv-filter-item-block row-block">
                  <img
                    class="checkbox"
                    :src="
                      selectedDatas[databaseOption.value].includes(dataOption.value) ? require('../../assets/images/checkbox-true.svg')
                      : require('../../assets/images/checkbox-false.svg')
                    "
                  >
                  <div class="case-detail-sv-filter-item-title ellipsis" :style="{ color: dataOption.color, 'font-weight': dataOption.bold ? 'bold' : '400', flex: 1 }" :title="$t(dataOption.title)">{{ $t(dataOption.title) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="case-detail-sv-filter-af-ds-container row-block flex-start">
        <div class="case-detail-sv-filter-af-container col-block width-full" :style="{ width: '132px' }">
          <div class="case-detail-sv-filter-af-title-container row-block">
            <div class="case-detail-sv-filter-af-title">{{ $t('DIALOG.caseDetailSVFilter.afFilter.___title') }}</div>
            <div :style="{ width: '8px' }"></div>
            <switchButton
              :disabled="false"
              :checked="switchData['af']"
              @input="c => switchData['af'] = c"
            ></switchButton>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="case-detail-sv-filter-af-main-container input-group col-block width-full">
            <div class="case-detail-sv-filter-af-mark-container row-block" :class="{ disabled: !switchData['af'] }">
              <div class="case-detail-sv-filter-af-mark">{{ '<' }}</div>
            </div>
            <input
              type="number"
              step="0.01"
              min="0"
              max="0.2"
              :placeholder="$t('DIALOG.caseDetailSVFilter.afFilter.___placeholder')"
              :disabled="!switchData['af']"
              v-model="inputData['af']"
            >
          </div>
        </div>
        <div class="case-detail-sv-filter-dosage-sensitivity-container col-block width-full" :style="{ flex: 1 }">
          <div class="case-detail-sv-filter-dosage-sensitivity-title-container row-block">
            <div class="case-detail-sv-filter-dosage-sensitivity-title">{{ $t('DIALOG.caseDetailSVFilter.DosageSensitivity.___title') }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="case-detail-sv-filter-dosage-sensitivity-selected-item-container">
            <div
              class="case-detail-sv-filter-dosage-sensitivity-item-container case-detail-sv-filter-item-container row-block"
              v-for="(dataOption, dindex) in dosageSensitivityOptions.options"
              :key="dindex"
              :class="{
                disabled: false
              }"
              :style="{ 'grid-column': 'span 1 / auto' }"
              @click="e => {
                selectedDatas['dosageSensitivity'] =
                  e.currentTarget.className.split(' ').includes('disabled') ? selectedDatas['dosageSensitivity']
                  : selectedDatas['dosageSensitivity'].includes(dataOption.value) ? selectedDatas['dosageSensitivity'].filter(data => data !== dataOption.value)
                  : selectedDatas['dosageSensitivity'].concat([dataOption.value])
              }"
            >
              <div class="case-detail-sv-filter-item-block row-block">
                <img
                  class="checkbox"
                  :src="
                    selectedDatas['dosageSensitivity'].includes(dataOption.value) ? require('../../assets/images/checkbox-true.svg')
                    : require('../../assets/images/checkbox-false.svg')
                  "
                >
                <div class="case-detail-sv-filter-item-title ellipsis" :style="{ color: dataOption.color, 'font-weight': dataOption.bold ? 'bold' : '400', flex: 1 }" :title="$t(dataOption.title)">{{ $t(dataOption.title) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="case-detail-sv-filter-caller-container col-block width-full">
        <div class="case-detail-sv-filter-caller-title-container row-block">
          <div class="case-detail-sv-filter-caller-title">{{ $t('DIALOG.caseDetailSVFilter.caller.___title') }}</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="case-detail-sv-filter-caller-main-container row-block flex-start">
          <div class="case-detail-sv-filter-caller-data-main-container col-block width-full" :style="{ flex: 1 }">
            <div
              class="case-detail-sv-filter-caller-data-main-block col-block width-full"
              v-for="(databaseOption, doindex) in svCallerOptions"
              :key="doindex"
              :style="{ flex: 1 }"
            >
              <div class="case-detail-sv-filter-caller-data-main-title-container row-block">
                <div class="case-detail-sv-filter-caller-data-main-title">{{ databaseOption.title }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ height: '10px' }"></div>
              <div class="case-detail-sv-filter-caller-data-selected-item-container row-block flex-wrap">
                <div
                  class="case-detail-sv-filter-caller-data-item-container case-detail-sv-filter-item-container row-block"
                  v-for="(dataOption, dindex) in databaseOption.options"
                  :key="dindex"
                  :class="{
                    disabled: false
                  }"
                  @click="e => {
                    selectedDatas[databaseOption.value] =
                      e.currentTarget.className.split(' ').includes('disabled') ? selectedDatas[databaseOption.value]
                      : selectedDatas[databaseOption.value].includes(dataOption.value) ? selectedDatas[databaseOption.value].filter(data => data !== dataOption.value)
                      : selectedDatas[databaseOption.value].concat([dataOption.value])
                  }"
                >
                  <div class="case-detail-sv-filter-item-block row-block">
                    <img
                      class="checkbox"
                      :src="
                        selectedDatas[databaseOption.value].includes(dataOption.value) ? require('../../assets/images/checkbox-true.svg')
                        : require('../../assets/images/checkbox-false.svg')
                      "
                    >
                    <div class="case-detail-sv-filter-item-title" :style="{ color: dataOption.color, 'font-weight': dataOption.bold ? 'bold' : '400' }">{{ $t(dataOption.title) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="case-detail-sv-filter-gq-container col-block width-full" :style="{ width: '132px' }">
            <div class="case-detail-sv-filter-gq-title-container row-block">
              <div class="case-detail-sv-filter-gq-title">{{ $t('DIALOG.caseDetailSVFilter.caller.genotypeQuality.___title') }}</div>
              <div :style="{ width: '8px' }"></div>
              <switchButton
                :disabled="false"
                :checked="switchData['gq']"
                @input="c => switchData['gq'] = c"
              ></switchButton>
              <div :style="{ width: '8px' }"></div>
              <borCor
                :reverse="true"
                :background="'white'"
                :border="'#CCCCCC'"
                :radius="'0px'"
                :blockStyle="{ padding: '10px' }"
              >
                <div slot="trigger">
                  <img :src="require('../../assets/images/info-circle-regular.svg')" alt="" :style="{ width: '16px' }">
                </div>
                <div slot="content">
                  <div>{{ $t('DIALOG.caseDetailSVFilter.caller.genotypeQuality.___info') }}</div>
                </div>
              </borCor>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="case-detail-sv-filter-gq-main-container input-group col-block flex-start">
              <input
                type="number"
                step="1"
                :disabled="!switchData['gq']"
                v-model="inputData['gq']"
              >
            </div>
          </div>
          <div class="case-detail-sv-filter-nc-container col-block width-full" :style="{ width: '132px' }">
            <div class="case-detail-sv-filter-nc-title-container row-block">
              <div class="case-detail-sv-filter-nc-title">{{ $t('DIALOG.caseDetailSVFilter.caller.numberOfCallers.___title') }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="case-detail-sv-filter-nc-main-container input-group col-block flex-start">
              <select v-model="inputData['nc']">
                <option v-for="(_, index) in Array(4).fill('')" :key="index" :value="index ? index : ''">{{ index ? index : '' }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => this.$emit('changeModal', {}, 'reset')">
        <span>{{ $t('COMMON.button.___reset') }}</span>
      </button>
      <button class="main-button circle-button" @click="e =>this.$emit('changeModal', {}, sendData)">
        <span>{{ $t('COMMON.button.___apply') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getSearchSVGeneEntry, getSearchSVDiseaseEntry } from '../../api'
import geneTag from '../tool/geneTag.vue'
import switchButton from '../tool/switchButton.vue'
import borCor from '../tool/newBorCor.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import {
  svClinvarOptions,
  svDECIPHEROptions,
  svDosageSensitivityOptions,
  svGenotypeOptions,
  svTypeOptions
} from '../../constants/global/data'

export default {
  components: {
    geneTag,
    switchButton,
    borCor
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // tag
      tagData: {
        map: {
          phenotype: {},
          gene: {}
        },
        query: {
          phenotype: '',
          gene: ''
        },
        tag: {
          phenotypes: {},
          genes: {}
        },
        curTag: {
          gene: null
        },
        searchTimer: {
          phenotype: [],
          gene: []
        }
      },
      // data
      inputData: {
        af: '',
        gq: '0',
        nc: ''
      },
      switchData: {
        af: false,
        gq: false
      },
      searchedDatas: {
        phenotypes: [],
        genes: []
      },
      selectedDatas: {
        phenotypes: [],
        genes: [],
        clinvar: [],
        DECIPHER: [],
        dosageSensitivity: [],
        genotype: [],
        svType: []
      }
    }
  },
  computed: {
    selectedLimit () {
      return {
        phenotypes: (this.sendData.phenotypes || []).length >= 10,
        genes: (this.sendData.genes || []).length >= 10
      }
    },
    sendData () {
      let sendData = {}
      // gene
      let selectedGenes = this.selectedDatas['genes']
      if (selectedGenes.length) {
        sendData.genes = [...selectedGenes]
      }
      // phenotype
      let selectedPhenotypes = this.selectedDatas['phenotypes']
      if (selectedPhenotypes.length) {
        sendData.phenotypes = [...selectedPhenotypes]
      }
      // variant databases
      sendData.clinvar = [...this.selectedDatas['clinvar']]
      sendData.DECIPHER = [...this.selectedDatas['DECIPHER']]
      // af ds
      sendData.af = {
        switch: this.switchData['af'],
        value: this.inputData['af']
      }
      sendData.dosageSensitivity = [...this.selectedDatas['dosageSensitivity']]
      // caller
      sendData.genotype = [...this.selectedDatas['genotype']]
      sendData.svType = [...this.selectedDatas['svType']]
      sendData.gq = {
        switch: this.switchData['gq'],
        value: this.inputData['gq']
      }
      sendData.nc = {
        value: this.inputData['nc']
      }
      return sendData
    },
    // static
    variantDatabaseOptions () {
      return [
        {
          title: this.$t('DIALOG.caseDetailSVFilter.variantDatabase.ClinVar.___title'),
          value: 'clinvar',
          options: svClinvarOptions
        },
        {
          title: this.$t('DIALOG.caseDetailSVFilter.variantDatabase.DECIPHER.___title'),
          value: 'DECIPHER',
          options: svDECIPHEROptions
        }
      ]
    },
    dosageSensitivityOptions () {
      return {
        options: svDosageSensitivityOptions
      }
    },
    svCallerOptions () {
      return [
        {
          title: this.$t('DIALOG.caseDetailSVFilter.caller.genotype.___title'),
          value: 'genotype',
          options: svGenotypeOptions
        },
        {
          title: this.$t('DIALOG.caseDetailSVFilter.caller.svType.___title'),
          value: 'svType',
          options: svTypeOptions.filter(option => option.filter !== false)
        }
      ]
    }
  },
  watch: {
    'switchData.af' (nv) {
      if (nv && [undefined, null, ''].includes(this.inputData['af'])) {
        this.inputData['af'] = 0.01
      }
    },
    'inputData.af' (nv, ov) {
      if (nv && nv !== ov) {
        if (nv < 0 || nv > 0.2) {
          this.inputData['af'] = Math.max(0, Math.min(0.2, nv))
        }
      }
    }
  },
  created () {
    this.init(this.param.defaultData)
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    init (defaultData) {
      if (defaultData) {
        // gene
        this.searchedDatas['genes'] = [...(defaultData.genes || [])]
        this.selectedDatas['genes'] = [...(defaultData.genes || [])]
        // phenotype
        this.searchedDatas['phenotypes'] = [...(defaultData.phenotypes || [])]
        this.selectedDatas['phenotypes'] = [...(defaultData.phenotypes || [])]
        // variant databases
        this.selectedDatas['clinvar'] = [...defaultData.clinvar]
        this.selectedDatas['DECIPHER'] = [...defaultData.DECIPHER]
        // af ds
        this.switchData['af'] = defaultData.af.switch
        this.inputData['af'] = defaultData.af.value
        this.selectedDatas['dosageSensitivity'] = [...defaultData.dosageSensitivity]
        // caller
        this.selectedDatas['genotype'] = [...defaultData.genotype]
        this.selectedDatas['svType'] = [...defaultData.svType]
        this.switchData['gq'] = defaultData.gq.switch
        this.inputData['gq'] = defaultData.gq.value
        this.inputData['nc'] = defaultData.nc.value
      }
    },
    async getGenes (query) {
      if ((this.tagData.curTag['gene'] || {}).name !== query) {
        this.tagData.tag['genes'] = {}
        if (this.tagData.searchTimer['gene']) {
          clearTimeout(this.tagData.searchTimer['gene'])
        }
        this.tagData.searchTimer['gene'] = setTimeout(async () => {
          if (!this.tagData.map['gene'][query] && query) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let response = null
              response = await getSearchSVGeneEntry(query, config)
              let genes = response.data.data.data
              this.tagData.map['gene'] = {
                ...this.tagData.map['gene'],
                [query]: {
                  info: null,
                  datas: [
                    ...genes.map(data => ({ ...data, id: data.name, type: 'gene' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.setLoadingAction(false)
          }
          this.tagData.tag['genes'] = this.tagData.map['gene'][query] || {}
        }, 500)
      }
    },
    async getPhenotypes (query) {
      if (!((this.tagData.tag['phenotypes'] || { datas: [] }).datas || []).map(data => data.query).includes(query)) {
        if (this.tagData.searchTimer['phenotype']) {
          clearTimeout(this.tagData.searchTimer['phenotype'])
        }
        this.tagData.searchTimer['phenotype'] = setTimeout(async () => {
          if (!this.tagData.map['phenotype'][query] && query) {
            this.setLoadingAction(true)
            try {
              let config = this.$ls.get('userInfo')
              let response = await getSearchSVDiseaseEntry(query, config)
              let phenotypes = response.data.data.data
              this.tagData.map['phenotype'] = {
                ...this.tagData.map['phenotype'],
                [query]: {
                  info: null,
                  datas: [
                    ...phenotypes.map(data => ({ ...data, id: data.name, phenotype_id: data.name.split(' ')[0], type: 'condition' }))
                  ]
                }
              }
            } catch (error) {
              this.addToast('error', !error.response ? error.message : error.response.data.result.message)
            }
            this.setLoadingAction(false)
          }
          this.tagData.tag['phenotypes'] = this.tagData.map['phenotype'][query] || {}
        }, 200)
      }
    },
    async addToSearch (type, data) {
      switch (type) {
        case 'gene': {
          data = data.type ? data : (this.tagData.map['gene'][this.tagData.query['gene']] || { datas: [] }).datas[0]
          if (data) {
            switch (data.type) {
              case 'gene': {
                let gene = { ...data }
                if (!this.searchedDatas['genes'].some(g => g.gene_id === gene.gene_id)) {
                  this.searchedDatas['genes'].push(gene)
                  if (!this.selectedLimit['genes']) {
                    this.selectedDatas['genes'].push(gene)
                  }
                }
                break
              }
              default: {}
            }
            this.tagData.query['gene'] = ''
            this.tagData.curTag['gene'] = null
          }
          break
        }
        case 'phenotype': {
          data = data.type ? data : (this.tagData.map['phenotype'][this.tagData.query['phenotype']] || { datas: [] }).datas[0]
          if (data) {
            switch (data.type) {
              case 'condition': {
                let phenotype = { ...data }
                if (!this.searchedDatas['phenotypes'].some(p => p.id === phenotype.id)) {
                  this.searchedDatas['phenotypes'].push(phenotype)
                  if (!this.selectedLimit['phenotypes']) {
                    this.selectedDatas['phenotypes'].push(phenotype)
                  }
                }
                break
              }
              default: {}
            }
            this.tagData.query['phenotype'] = ''
            this.tagData.curTag['phenotype'] = null
          }
          break
        }
        default: {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailSVFilter.vue